import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';
export const findProductStatistics= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/order/statistics?`+params,
        method: 'GET'
    })
}
export const findProductStatisticsDownloadExcel= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/order/statistics/downloadExcel?`+params,
        method: 'GET'
    })
}